export const GEN_ROOT_SEGMENT = 'gen';
export const DAMAGE_TAB_ROUTE_SEGMENT = 'damage';
export const BOOSTS_TAB_ROUTE_SEGMENT = 'boosts';
export const ROUTE_LANGS = ['fr', 'en', 'es', 'de', 'pt'];

/** Leading /<lang> segment, and only that. The lookahead is load-bearing: without
 *  it `en` matches the start of `/encyclopedia`, and a bare /[a-z]{2} pattern eats
 *  the first two letters of every unprefixed path (/gen -> /fr/n, 404). */
const LANG_PREFIX_RE = new RegExp(`^/(?:${ROUTE_LANGS.join('|')})(?=/|$)/?`);

/** Path with its language prefix removed, no leading slash. '/fr/gen' -> 'gen',
 *  and an already-unprefixed '/gen' -> 'gen' (not 'n'). */
export function stripLangPrefix(pathname) {
    return (pathname || '').replace(LANG_PREFIX_RE, '').replace(/^\//, '');
}

/**
 * Route segment a generator data tab lives under, or null for stats.
 *
 * Accepts the tab value ('spells') and the segment itself ('damage'), because
 * both shapes are passed around: the tab state names the tab, the route names
 * the segment, and 'spells' is the legacy spelling of the damage path.
 */
export function routeSegmentForTab(dataTab) {
    if (dataTab === DAMAGE_TAB_ROUTE_SEGMENT || dataTab === 'spells') return DAMAGE_TAB_ROUTE_SEGMENT;
    if (dataTab === BOOSTS_TAB_ROUTE_SEGMENT) return BOOSTS_TAB_ROUTE_SEGMENT;
    return null;
}

function suffixForTab(dataTab) {
    const segment = routeSegmentForTab(dataTab);
    return segment ? `/${segment}` : '';
}

export function localGenPath(lang, dataTab = null) {
    return `/${lang}/${GEN_ROOT_SEGMENT}${suffixForTab(dataTab)}`;
}

export function canonicalBuildPath(lang, userSlug, buildCode, dataTab = null) {
    return `/${lang}/${GEN_ROOT_SEGMENT}/${userSlug}/${buildCode}${suffixForTab(dataTab)}`;
}

const GEN_DATA_TAB_SUFFIX_RE = new RegExp(
    `^(/[^/]+/${GEN_ROOT_SEGMENT}(?:/[^/]+/[^/]+)?)/(?:${DAMAGE_TAB_ROUTE_SEGMENT}|spells|${BOOSTS_TAB_ROUTE_SEGMENT})$`
);

/** Pathname key for scroll reset — ignores the generator's data-tab segment. */
export function scrollResetPathKey(pathname) {
    if (!pathname) return pathname;
    const withoutTab = pathname.replace(GEN_DATA_TAB_SUFFIX_RE, '$1');
    return withoutTab;
}

